export default __webpack_public_path__ + "static/media/battery-100.abda115e.svg";